import React from 'react';
import SettingsView from './SettingsView';
import { SettingsPath } from './SettingsChrome';
import { useLanguage } from '../../i18n/LanguageContext';
import { SETTINGS_HOME } from './settings-paths';
import './settings-home.css';

const ThemeSettingsPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="set">
      <SettingsPath
        items={[{ label: t('settings.back'), to: SETTINGS_HOME }, { label: t('settings.home.theme.title') }]}
      />
      <SettingsView />
    </div>
  );
};

export default ThemeSettingsPage;
